import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRoundTube = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 128 128",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5
	},
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "matrix(0.989425,0,0,0.989425,-0.0263151,-4.48626)",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 64.711,
			cy: 69.218,
			r: 50.534,
			style: {
				fill: "none",
				stroke: "rgb(41,41,41)",
				strokeWidth: "18.19px"
			}
		})
	})
});
export default SvgRoundTube;
